"use strict";

var _interopRequireDefault = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.regexp.search");
var _objectWithoutProperties2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/objectWithoutProperties.js"));
var _regenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _Pagination = _interopRequireDefault(require("@/components/Pagination"));
var _batchInDetail = _interopRequireDefault(require("@/components/wareHouse/batchInDetail.vue"));
var _batchOutDetail = _interopRequireDefault(require("@/components/wareHouse/batchOutDetail.vue"));
var _batchInEdit = _interopRequireDefault(require("@/components/wareHouse/batchInEdit.vue"));
var _batchOutEdit = _interopRequireDefault(require("@/components/wareHouse/batchOutEdit.vue"));
var _batchTransferEdit = _interopRequireDefault(require("@/components/wareHouse/batchTransferEdit.vue"));
var _warehouse = require("@/api/warehouse");
var _multiLanguageDisplay = require("@/utils/multiLanguageDisplay");
var _excluded = ["daterange"]; //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    Pagination: _Pagination.default,
    BatchInDetail: _batchInDetail.default,
    BatchOutDetail: _batchOutDetail.default,
    BatchInEdit: _batchInEdit.default,
    BatchOutEdit: _batchOutEdit.default,
    BatchTransferEdit: _batchTransferEdit.default
  },
  data: function data() {
    return {
      multiLanguageDisplay: _multiLanguageDisplay.multiLanguageDisplay,
      search: {
        daterange: [],
        warehouseId: '',
        //仓库id
        locationId: '',
        //库位id
        billNo: '',
        //单据号(流水号)
        styleNo: '' //商品款号
      },
      wareList: [],
      LocationList: [],
      list: [],
      operateType: 1,
      //1--入库  2--出库 3--调拨
      listLoading: true,
      total: 0,
      pageNo: 1,
      pageSize: 10,
      info: {},
      selectData: [[], []]
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.getList();
    this.getHouse();
  },
  methods: {
    handleSelectionChange: function handleSelectionChange(val) {
      if (this.operateType == 1) {
        this.selectData[0] = val.map(function (item) {
          return item.inoutId;
        });
        console.log(this.selectData[0], 1);
      }
      if (this.operateType == 2) {
        this.selectData[1] = val.map(function (item) {
          return item.inoutId;
        });
        console.log(this.selectData[1], 2);
      }
    },
    // 查找
    onSearch: function onSearch() {
      this.pageNo = 1;
      this.getList();
    },
    onClear: function onClear() {
      this.search = {
        daterange: [],
        warehouseId: '',
        //仓库id
        locationId: '',
        //库位id
        billNo: '',
        //单据号(流水号)
        styleNo: ''
      };
      this.wareList = [], this.LocationList = [], this.pageNo = 1;
      this.getList();
    },
    // 删除
    onDelet: function onDelet() {
      var _this = this;
      var paramsData = [];
      if (this.operateType == 1) {
        paramsData = this.selectData[0];
      }
      if (this.operateType == 2) {
        paramsData = this.selectData[1];
      }
      this.$confirm('是否要进行删除操作?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        (0, _warehouse.deleteBatchApi)({
          inoutIds: paramsData
        }).then(function (res) {
          if (res.data.errno == 0) {
            _this.$message.success('删除成功');
            _this.getList();
          } else {
            _this.$message.warning(res.data.msg);
          }
        });
      }).catch(function () {
        _this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    // 仓库详情
    getDetail: function () {
      var _getDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee(id) {
        var data, res;
        return (0, _regenerator2.default)().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              _context.n = 1;
              return (0, _warehouse.listBillDetailApi)({
                inoutId: id
              });
            case 1:
              data = _context.v;
              res = data.data;
              if (res.errno == 0) {
                this.info = res.data;
              }
            case 2:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function getDetail(_x) {
        return _getDetail.apply(this, arguments);
      }
      return getDetail;
    }(),
    // 仓库列表
    getHouse: function getHouse() {
      var _this2 = this;
      (0, _warehouse.warehouseListApi)({}).then(function (data) {
        var res = data.data;
        if (res.errno == 0) {
          _this2.wareList = res.data;
        }
      });
    },
    selectWare: function selectWare(val) {
      this.getListLocation(val);
    },
    // 库位列表
    getListLocation: function getListLocation(val) {
      var _this3 = this;
      var params = {
        warehouseId: val
      };
      (0, _warehouse.listLocationListApi)(params).then(function (data) {
        var res = data.data;
        if (res.errno == 0) {
          _this3.LocationList = res.data;
        }
      });
    },
    toDetail: function () {
      var _toDetail = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(item) {
        return (0, _regenerator2.default)().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.getDetail(item.inoutId);
            case 1:
              if (this.operateType == 1) {
                this.$refs.batchInDetail.open(this.info);
              }
              if (this.operateType == 2 || this.operateType == 3) {
                this.$refs.batchOutDetail.open(this.info, this.operateType);
              }
            case 2:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function toDetail(_x2) {
        return _toDetail.apply(this, arguments);
      }
      return toDetail;
    }(),
    toEdit: function () {
      var _toEdit = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(item) {
        return (0, _regenerator2.default)().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              _context3.n = 1;
              return this.getDetail(item.inoutId);
            case 1:
              if (this.operateType == 1) {
                this.$refs.batchInEdit.open(this.info, item.inoutId);
              }
              if (this.operateType == 2) {
                this.$refs.batchOutEdit.open(this.info, item.inoutId);
              }
              if (this.operateType == 3) {
                this.$refs.batchTransferEdit.open(this.info, item.inoutId);
              }
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function toEdit(_x3) {
        return _toEdit.apply(this, arguments);
      }
      return toEdit;
    }(),
    getList: function getList() {
      var _this4 = this;
      // console.log(value);
      this.listLoading = true;
      var _this$search = this.search,
        daterange = _this$search.daterange,
        data = (0, _objectWithoutProperties2.default)(_this$search, _excluded);
      var params = (0, _objectSpread2.default)((0, _objectSpread2.default)({}, data), {}, {
        startDate: this.search.daterange[0],
        endDate: this.search.daterange[1],
        bizType: this.operateType,
        pageNo: this.pageNo,
        pageSize: this.pageSize
      });
      (0, _warehouse.listBillApi)(params).then(function (data) {
        var res = data.data;
        if (res.errno == 0) {
          _this4.listLoading = false;
          _this4.list = res.data.list;
          _this4.total = res.data.total;
        }
      });
    },
    // 出入库类型改变
    onChangeType: function onChangeType(val) {
      this.operateType = val;
      this.pageNo = 1;
      this.onClear();
      this.getList();
    },
    handlePrint: function handlePrint(item) {
      var _this5 = this;
      // 调用打印接口
      if (!item.billNo) {
        this.$message.error('单号不能为空');
        return;
      }
      this.$message.info('正在获取打印链接，请稍候...');

      // 调用接口获取PDF链接
      (0, _warehouse.getOutboundPdfApi)({
        billNo: item.billNo
      }).then(function (response) {
        // 如果返回的是URL链接
        if (response.data && response.data.errno === 0 && response.data.data) {
          // 获取URL链接
          var url = response.data.data.url;

          // 在新窗口中打开链接
          window.open(url, '_blank');
        } else {
          _this5.$message.error('获取打印链接失败：返回的数据格式不正确');
          console.error('获取打印链接失败，返回数据:', response);
        }
      }).catch(function (error) {
        console.error('获取打印链接失败:', error);
        _this5.$message.error('获取打印链接失败，请稍后重试');
      });
    }
  }
};